<template>
    <div>
        <b-modal ref="player" id="player" :title="modalTitle" @hidden="closedown" size="xl" centered visible>
            <div v-if="player" class="row">
                <div class="col-sm-12 col-md-6">
                    <dl>
                        <dt><h6>Price Breakdown<template v-if="player.isFirstBooking"> - <span class="text-primary"><i class="fas fa-fw fa-star-of-life"></i> First Game <i class="fas fa-fw fa-star-of-life"></i></span></template></h6></dt>
                        <dd>
                            <table class="table table-responsive-sm">
                                <thead>
                                    <th class="col-sm-7">Item</th>
                                    <th class="col-sm-3">Price</th>
                                    <th class="col-sm-2"></th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="d-flex"><span>Game Price</span>&nbsp;
                                            <template v-if="player.free_pass">
                                                <button class="btn btn-danger btn-sm ml-auto" @click="toggleFreePass"><i class="far fa-fw fa-id-card"></i> Remove Game Pass</button>
                                            </template>
                                            <template v-else>
                                                <button class="btn btn-success btn-sm ml-auto" @click="toggleFreePass"><i class="far fa-fw fa-id-card"></i> Add Game Pass</button>
                                            </template>
                                        </td>
                                        <template v-if="player.free_pass">
                                            <td>&pound; 0.00</td>
                                        </template>
                                        <template v-else>
                                            <td>&pound; {{ (player.price / 100).toFixed(2) }}</td>
                                        </template>
                                        <td></td>
                                    </tr>
                                    <template v-if="player.rentals && player.rentals.length">
                                        <tr>
                                            <td colspan="3">Rentals</td>
                                        </tr>
                                        <tr v-for="rental in player.rentals" :key="rental.id">
                                            <td>{{ rental.rental_type.name }}</td>
                                            <td>&pound; {{ (rental.rental_type.price / 100).toFixed(2) }}</td>
                                            <td><b-button variant="danger" size="sm" @click="removeRental(rental)"><i class="far fa-fw fa-times"></i></b-button></td>
                                        </tr>
                                    </template>
                                    <!-- <template v-if="player.extras && player.extras.length">
                                        <tr>
                                            <td colspan="3">Extras</td>
                                        </tr>
                                        <tr v-for="extra in player.extras" :key="extra.id">
                                            <td>{{ extra.note }}</td>
                                            <td>&pound; {{ (extra.price / 100).toFixed(2) }}</td>
                                            <td><b-button variant="danger" size="sm"><i class="far fa-fw fa-times"></i></b-button></td>
                                        </tr>
                                    </template> -->
                                    <tr class="table-secondary">
                                        <td class="d-flex justify-content-end">Total</td>
                                        <td>&pound; {{ (priceTotal / 100).toFixed(2) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr class="table-secondary">
                                        <td class="d-flex justify-content-end">Paid</td>
                                        <td>&pound; {{ (payments / 100).toFixed(2) }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </dd>
                    </dl>
                </div>
                <div class="col-sm-12 col-md-6">
                    <h6>Actions</h6>
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <dl class="border p-2 rounded">
                                <dt>Addons</dt>
                                <dd>
                                    <b-button v-b-modal.rentalsModal variant="secondary" block><i class="far fa-fw fa-crosshairs"></i> Add Rental</b-button>
                                    <b-button @click="showPayment" variant="secondary" block><i class="fas fa-fw fa-dollar-sign"></i> Add Payment</b-button>
                                    <!-- <b-button variant="secondary" block><i class="far fa-fw fa-plus"></i> Add Extra</b-button> -->
                                </dd>
                            </dl>
                            <dl class="border p-2 rounded">
                                <dt>Teams</dt>
                                <dd>
                                    <b-form-select v-model="player.team_id" :options="teamOptions" @change="updateTeam" block></b-form-select>
                                </dd>
                            </dl>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <dl class="border p-2 rounded">
                                <dt>Status</dt>
                                <dd>
                                    <b-button @click="arrived" v-if="player.state == 'booked' || player.state == 'arrived'" :variant="player.state == 'no-show' ? 'success-o' : 'success'" block><i class="far fa-fw fa-check"></i> Arrived</b-button>
                                    <b-button @click="noShow" v-if="player.state == 'booked' || player.state == 'no-show'" :variant="player.state == 'arrived' ? 'warning-o' : 'warning'" block><i class="far fa-fw fa-ban"></i> No Show</b-button>
                                    <b-button @click="resetState" v-if="player.state == 'no-show' || player.state == 'arrived'" variant="danger" block><i class="fas fa-fw fa-retweet"></i> Reset</b-button>
                                </dd>
                                <dt>Other</dt>
                                <dd>
                                    <b-button @click="newMarshalNote" variant="secondary" block>Add Marshal Note</b-button>
                                </dd>
                            </dl>
                            <dl v-if="$can('booking-delete')" class="border p-2 rounded">
                                <dt></dt>
                                <dd>
                                    <b-button @click="deleteBooking" variant="danger" type="button" block><i class="fal fa-fw fa-trash-alt"></i> Delete Booking</b-button>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="addNote" class="row">
                <div class="col-12">
                    <dl class="border p-2 rounded">
                        <dt>Add Marshal Note</dt>
                        <dd>
                            <ul>
                                <b-form>
                                    <b-form-group>
                                        <b-form-textarea v-model="note.message" rows="6" placeholder="Enter your note here"></b-form-textarea>
                                    </b-form-group>
                                    <b-form-group>
                                        <b-button variant="secondary" @click="cancelMarshalNote">Cancel</b-button>
                                        <b-button variant="success" @click="addMarshalNote">Add Note</b-button>
                                    </b-form-group>
                                </b-form>
                            </ul>
                        </dd>
                    </dl>
                </div>
            </div>
            <div v-if="player && player.notes.length && ! addNote" class="row">
                <div class="col-12">
                    <dl class="border p-2 rounded">
                        <dt>Marshal Notes</dt>
                        <dd>
                            <dl v-for="note in player.notes" :key="note.id" class="border p-2 rounded">
                                <dt>
                                    <div class="note-header">
                                        <span>
                                            {{ note.user.name }}
                                            <template v-if="note.edit"> <small>Editted by {{ note.edit.name }}</small></template>
                                        </span>
                                        <b-button @click="deleteNote(note)" size="sm" class="float-right" variant="danger"><i class="fal fa-fw fa-trash"></i> Delete Note</b-button></div></dt>
                                <dd>{{ note.message }}</dd>
                            </dl>
                        </dd>
                    </dl>
                </div>
            </div>
            <template #modal-footer>
                <div class="w-100 d-flex justify-content-between">
                    <div class="px-1"></div>
                    <div>
                        <!-- <b-button variant="success"><i class="fas fa-fw fa-dollar-sign"></i> <template v-if="player.deposit">Unmark</template><template v-else>Mark</template> Deposit Paid</b-button>
                        <b-button variant="success"><i class="fas fa-fw fa-dollar-sign"></i> <template v-if="player.paid !== player.game_price_total">Add</template><template v-else>Alter</template> Payment</b-button>
                        <b-button v-if="player.paid !== player.game_price_total" variant="success"><i class="fas fa-fw fa-dollar-sign"></i> Fully Paid</b-button> -->
                    </div>
                    <b-button @click="close">Close</b-button>
                </div>
            </template>
        </b-modal>
        <b-modal ref="rentalsModal" id="rentalsModal" title="Add Rentals" size="xl" centered @show="loadRentalTypes">
            <template v-if="rentalTypes.length">
                <table class="table table-hover">
                    <thead>
                        <th>Name</th>
                        <th>Long Name</th>
                        <th class="col-lg-2 col-sm-3">Price</th>
                        <th class="col-lg-1 col-sm-2"></th>
                    </thead>
                    <tbody>
                        <tr v-for="rentalType in rentalTypes" v-if="checkRental(rentalType)" :key="rentalType.id">
                            <td>{{ rentalType.name }}</td>
                            <td>{{ rentalType.long_name }}</td>
                            <td class="col-lg-2 col-sm-3">&pound; {{ (rentalType.price / 100).toFixed(2) }}</td>
                            <td class="col-lg-1 col-sm-2" @click="addRental(rentalType)"><b-button variant="success" size="sm"><i class="far fa-fw fa-plus"></i></b-button></td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <template #modal-footer>
                <b-button @click="closeRental">Close</b-button>
            </template>
        </b-modal>
        <game-player-payment-modal v-if="player" :bookingRaw="player" @closing="paymentClosed"></game-player-payment-modal>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: false,
        },
        gameRaw: {
            default: false,
        },
        sites: {
            default: false,
        }
    },
    data() {
        return {
            loading: false,
            player: false,
            showRentalModal: false,
            showPaymentModal: false,
            rentalTypes: [],
            game: false,
            modal: window.modal,
            teams: [],
            addNote: false,
            note: {
                message: null,
            },
        }
    },
    watch: {
        id() {
            if (this.id) {
                this.loadPlayer();
            }
        },
        player: {
            deep: true,
            handler(player, old) {
                // console.log('old', old, 'player', player)

            }
        },
    },
    computed: {
        teamOptions() {
            if ( ! this.teams.length) {
                return [];
            }

            return this.teams.map(team => {
                return { value: team.id, text: team.name };
            });
        },
        modalTitle() {
            if ( ! this.player) {
                return 'Loading';
            }

            return `Player (${this.player.id}) - ${this.player.member.forename} ${this.player.member.surname}`;
        },
        visible() {
            return this.player;
        },
        priceTotal() {
            let price = (this.player.free_pass) ? 0 : this.player.price;

            if (this.player.rentals && this.player.rentals.length) {
                this.player.rentals.forEach(rental => {
                    price += rental.rental_type.price;
                });
            }

            return price;
        },
        payments() {
            if (this.player && !this.player.payments.length) {
                return 0;
            } else if (this.player) {
                return this.player.payments.reduce((total, payment) => total + payment.amount, 0);
            } else {
                return 0;
            }
        }
    },
    methods: {
        newMarshalNote() {
            this.addNote = true;
        },
        cancelMarshalNote() {
            this.note.message = null;
            this.addNote = false;
        },
        addMarshalNote() {
            axios.post(this.$routes.route('note.storeForBooking', {booking: this.player.id}), this.note)
            .then((response) => {
                this.cancelMarshalNote();
                this.loadPlayer();
            })
            .catch((e) => {
                console.error(e);
            });
        },
        deleteNote(note) {
            this.modal.confirm(() => {
                // Remove the note from the player object
                this.player.notes = this.player.notes.filter(n => n.id !== note.id);

                axios.delete(this.$routes.route('note.destroy', {note: note.id}))
                    .then((response) => {
                        this.loadPlayer();
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            });
        },
        close() {
            this.$refs.player.hide();
        },
        closeRental() {
            this.$refs.rentalsModal.hide();
            this.loadPlayer();
        },
        closedown() {
            this.player = false;
            this.loading = false;
            setTimeout(() => {
                this.$emit('player-closing');
            }, 100);
        },
        checkRental(rentalType) {
            return this.game.rentalLimits[rentalType.id] > 0 || rentalType.unlimited;
        },
        loadPlayer() {
            axios.get(this.$routes.route('booking.show', {booking: this.id}))
            .then((response) => {
                this.loading = false;
                this.player = response.data;
            })
            .catch((e) => {
                this.loading = false;
                console.error(e);
            });
            axios.get(this.$routes.route('game.show', {game: this.gameRaw.id}))
            .then((response) => {
                this.game = response.data;
            })
            .catch((e) => {
                console.error(e);
            });
        },
        loadRentalTypes() {
            axios.get(this.$routes.route('rentaltype.index'))
            .then((response) => {
                this.rentalTypes = response.data;
            })
            .catch((e) => {
                console.error(e);
            })
            
            axios.get(this.$routes.route('game.show', {game: this.gameRaw.id}))
            .then((response) => {
                this.game = response.data;
            })
            .catch((e) => {
                console.error(e);
            });
        },
        addRental(rentalType) {
            axios.post(this.$routes.route('rental.store'), { booking_id: this.id, rental_type_id: rentalType.id })
            .then((response) => {
                this.closeRental();
                
                axios.get(this.$routes.route('game.show', {game: this.gameRaw.id}))
                .then((response) => {
                    this.game = response.data;
                })
                .catch((e) => {
                    console.error(e);
                });
            })
            .catch((e) => {
                console.error(e);
            })
        },
        removeRental(rental) {
            axios.delete(this.$routes.route('rental.destroy', { rental: rental.id }))
            .then((response) => {
                this.loadPlayer();
            })
            .catch((e) => {
                console.error(e);
            })
        },
        arrived() {
            // this.player.show = true;
            // this.player.no_show = false;
            this.player.state = 'arrived';
            axios.put(this.$routes.route('booking.update', {booking: this.id}), { state: this.player.state})
                .then((response) => {})
                .catch((e) => {
                    console.error(e);
                });

            let paymentOutstanding = this.priceTotal - this.payments;
            if (paymentOutstanding > 0) {
                axios.post(this.$routes.route('payment.store'), { booking_id: this.id, amount: paymentOutstanding })
                .then((response) => {
                    this.loadPlayer();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.close();
                });
            } else {
                this.close();
            }
        },
        noShow() {
            // this.player.no_show = true;
            // this.player.show = false;
            this.player.state = 'no-show';
            axios.put(this.$routes.route('booking.update', {booking: this.id}), { state: this.player.state})
                .then((response) => {
                    this.close();
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        resetState() {
            this.player.state = 'booked';
            axios.put(this.$routes.route('booking.update', {booking: this.id}), { state: this.player.state})
                .then((response) => {
                    this.close();
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        toggleFreePass() {
            this.player.free_pass = !this.player.free_pass;
            axios.put(this.$routes.route('booking.update', {booking: this.id}), { free_pass: this.player.free_pass})
                .then((response) => {
                    this.loadPlayer();
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        showPayment() {
            this.showPaymentModal = true;
            this.$bvModal.show('payment');
        },
        paymentClosed() {
            this.showPaymentModal = false;
            this.loadPlayer();
        },
        toggleDeposit() {},
        togglePayment() {},
        fullyPaid() {},
        deleteBooking() {
            this.modal.confirm(() => {
                axios.delete(this.$routes.route('booking.destroy', {booking: this.id}))
                    .then((response) => {
                        this.$emit('booking-deleted');
                        this.close();
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }, () => {});
            // if (confirm('Are you sure you want to delete this booking?')) {
            //     axios.delete(this.$routes.route('booking.destroy', {booking: this.id}))
            //         .then((response) => {
            //             this.$emit('booking-deleted');
            //             this.close();
            //         })
            //         .catch((e) => {
            //             console.error(e);
            //         });
            // }
        },
        loadTeams() {
            axios.get(this.$routes.route('team.index', {getData: true}))
            .then((response) => {
                this.teams = response.data;
            })
            .catch((e) => {
                console.error(e);
            });
        },
        updateTeam() {
            axios.put(this.$routes.route('booking.assignTeam', {booking: this.player.id, team: this.player.team_id}))
            .then((response) => {
                this.loadPlayer();
            })
            .catch((e) => {
                console.error(e);
            });
        },
    },
    mounted() {
        if (this.id) {
            this.loading = true;
            this.loadTeams();
            this.loadPlayer();
        }
    },
}
</script>